import React from "react";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

const normalize = (v) => String(v ?? "").trim();

const getSafeValue = (list, value) => {
  const v = normalize(value);
  if (!v) return "";

  const exists = list?.some(
    (item) => normalize(item.value) === v
  );

  return exists ? v : "";
};

const FormSelect = ({
  list = [],
  value = "",
  onChange = () => {},
  placeholder = "Select",
  disabled = false,
}) => {

  const safeValue = getSafeValue(list, value);

  return (
    <Select
      value={safeValue} // ✅ NEVER undefined
      onValueChange={(val) => onChange(normalize(val))}
      disabled={disabled}
    >
      <SelectTrigger className="bg-white border border-gray-300 rounded-md">
        <SelectValue placeholder={placeholder} />
      </SelectTrigger>

      <SelectContent className="bg-white z-50 max-h-60 overflow-y-auto">
        {list.length > 0 ? (
          list.map((item) => (
            <SelectItem
              key={item._id || item.value}
              value={normalize(item.value)}
            >
              {item.label}
            </SelectItem>
          ))
        ) : (
          <div className="p-2 text-sm text-gray-500">
            No options available
          </div>
        )}
      </SelectContent>
    </Select>
  );
};

export default FormSelect;